// TwoTwoFiveSeven.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import TwoTwoFiveSeven from '../page/TwoTwoFiveSeven.jsx';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(TwoTwoFiveSeven);
